
import './PageNavScrollTrigger.scss';

/**************
 * 
 * Docs:
 * use on Toggle Sections 
 *    class="pageNavItem"
 * use data Attribute
 *    data-pagenav="title Shown in Nav"
 * 
 * 
 *  */



class PageNavScrollTrigger {
    constructor(options = {}) {
        this.options = options;
        this.scrollData = {
            direction: undefined,
            prevPosition: 0
        }
        this.DOM = {
            sections: [...document.querySelectorAll('*[data-pagenav]')],
            pageNav: [document.getElementById('pageNav')],
            pageNavList: document.getElementById('pageNavList'),
            pageNavLinks: []
        }


        this.initPageNav()


        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                this.setScrollDirection()

                if (this.scrollData.direction === 'down' && entry.intersectionRatio === 0) {
                    this.changeActiveLink(this.getActiveSectionDownScroll(entry));
                    console.log(entry.target, 'down')
                }
                else if (this.scrollData.direction === 'up' && entry.intersectionRatio > 0) {
                    this.changeActiveLink(entry.target);

                }
                else if (this.scrollData.direction === 'notScrolled' && document.documentElement.scrollTop === 0) {

                    this.changeActiveLink(this.DOM.sections[0]);
                    console.log(entry.target)
                }
            });
        }, {
            rootMargin: `-50%`,
            // threshold: '1'
        });
        this.addEvents()
    }
    initPageNav = () => {
        this.fillPageNav()

    }
    fillPageNav = () => {
        this.DOM.sections.forEach(section => {
            const listItem = document.createElement('li')
            const pageNavLink = document.createElement('a')
            pageNavLink.href = `#${section.getAttribute('id')}`
            pageNavLink.classList.add('d-flex', 'justify-content-between', 'align-items-center')

            const listDotSpan = document.createElement('span');
            listDotSpan.classList.add('listDot')
            pageNavLink.append(listDotSpan)
            const textSpan = document.createElement('span')
            textSpan.innerHTML = section.dataset.pagenav
            textSpan.classList.add('textSpan')
            pageNavLink.prepend(textSpan)

            listItem.append(pageNavLink)
            this.DOM.pageNavLinks.push(pageNavLink)
            this.DOM.pageNavList.appendChild(listItem)
        })
    }
    addEvents = () => {
        this.DOM.sections.forEach(section => this.observer.observe(section))
    }

    setScrollDirection = () => {
        const currentScroll = document.documentElement.scrollTop
        if (currentScroll > this.scrollData.prevPosition) {
            this.scrollData.direction = "down"
        }
        else if (currentScroll < this.scrollData.prevPosition) {
            this.scrollData.direction = "up"
        }
        else {
            this.scrollData.direction = "notScrolled"
        }

        this.scrollData.prevPosition = currentScroll;




    }

    changeActiveLink = (nextSection) => {
        this.DOM.pageNavLinks.forEach(link => link.classList.remove('active'))
        const el1 = document.querySelector(`[href="#${nextSection.id}"]`);
        el1.classList.add('active')
    }

    getActiveSectionDownScroll = (entry) => {
        const currentSection = this.DOM.sections.findIndex((el) => el === entry.target)
        const nextSectionIndex = (currentSection < this.DOM.sections.length - 1) ? currentSection + 1 : currentSection
        return this.DOM.sections[nextSectionIndex]
    }
}

export {
    PageNavScrollTrigger
}